import { Box, Stack, Typography } from "@mui/material";
import { RecipeListCard } from "./RecipeListCard";
import RecipeTable from "./RecipeTable";
import emptyIcon from "../../../assets/images/Icons/search-table.png";

export const ProductionChartRecipeDetails = (props) => {
  const {
    data,
    productionchart,
    handleRecipeSelect,
    globalData,
    onDownloadPCByCategoryId,
    downloadProductionChartByCategory,
    toggleAllProducts,
    setToggleAllProducts,
  } = props;

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        maxHeight: { md: "calc(100vh - 154px)", xs: "100%" },
      }}
    >
      <RecipeListCard
        recipes={data}
        state={productionchart}
        globalData={globalData}
        handleRecipeSelect={handleRecipeSelect}
        toggleAllProducts={toggleAllProducts}
        setToggleAllProducts={setToggleAllProducts}
        onDownloadPCByCategoryId={onDownloadPCByCategoryId}
        downloadProductionChartByCategory={downloadProductionChartByCategory}
      />

      <Box
        sx={{
          paddingInline: "12px",
          paddingBottom: "12px",
          flex: 1,
          maxHeight: { md: "calc(100vh - 154px)", xs: "100%" },
          overflowY: { md: "auto" },
        }}
      >
        {productionchart?.selectedOtherRecipe ? (
          <RecipeTable
            // recipe={data[productionchart?.selectedRecipeIndex]}
            recipe={productionchart.selectedOtherRecipe}
            globalData={globalData}
          />
        ) : (
          <Stack
            sx={{
              flex: 1,
              flexShrink: 1,
              height: "calc(100dvh - 170px)",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={emptyIcon} alt="empty" height={56} width={56} />
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#485364",
                width: "500px",
                textAlign: "center",
              }}
            >
              No recipe selected yet.
            </Typography>
          </Stack>
        )}
      </Box>
    </Stack>
  );
};
